import { DATA_TYPE } from '@/store/modules/cards/constants';

export default {
  tumblrColor: '#36465D',
  notClassifiedColor: '#98999D',
  negativeColor: '#CC1C14',
  youtubeColor: '#FF0000',
  googleplusColor: '#D34836',
  zapierColor: '#FF4A00',
  blogsColor: '#FF6600',
  googleplayColor: '#FF9C00',
  neutralColor: '#F7AE16',
  buscapeColor: '#FFCB04',
  instagramColor: '#FBD63F',
  womanColor: '#FF63D4',
  officeColor: '#8B52A1',
  siteColor: '#8C51A1',
  facebookColor: '#6470BC',
  linkedinColor: '#007AB9',
  googlemybusinessColor: '#518EF8',
  manColor: '#059FF5',
  twitterColor: '#56B6F3',
  computerColor: '#8EB8D6',
  forunsColor: '#439B41',
  comentariosemartigosColor: '#439B41',
  newsColor: '#439B41',
  foursquareColor: '#84CA32',
  reclameaquiColor: '#77BF40',
  positiveColor: '#2AAE6E',
  tvColor: '#4E9A8F',
  mobileColor: '#96CEBC',
  defaultSerieColor: '#23b4d4',
  radioColor: '#5fc2b7',
  impressasColor: '#79dcd1',
  portaisColor: '#2c8f84',
  blipColor: '#1877F2',
  hotnessColor: [
    '#5FC2B7',
    '#69C4AF',
    '#9CCF87',
    '#BCD56E',
    '#D7DB58',
    '#F7830B',
  ],
  graphColor: {
    dark: {
      edge: '#e1e1e1',
      node: '#ffffff',
    },
    light: {
      edge: '#C3C3C3',
      node: '#373737',
    },
  },
  componentsColor: {
    seriesLineColor: '#23b4d4',
    seriesAreaColorStart: 'rgba(44, 216, 255, .3)',
    seriesAreaColorEnd: 'rgba(44, 216, 255, 0)',
    seriesBrandPure: '#73D0E6',
    seriesYellow56: '#FBCF23',
  },
  statusColor: {
    pending: '#E91D00',
    opened: '#FFB500',
    holding: '#8B52A1',
    replied: '#4FE6E3',
    closed: '#00D85A',
    ignored: '#C1C2C4',
  },
  support: {
    '5': '#b7e55e',
  },
  dataType: {
    [DATA_TYPE.LISTENING]: {
      color: '#AA5AFF',
      rgba: 'rgba(170, 90, 255, 0.16)',
    },
    [DATA_TYPE.PAGE]: {
      color: '#FD2774',
      rgba: 'rgba(253, 39, 116, 0.16)',
    },
    [DATA_TYPE.SAC]: {
      color: '#FD2774',
      rgba: 'rgba(253, 39, 116, 0.16)',
    },
    [DATA_TYPE.SAC_STATUS]: {
      color: '#FF9F5A',
      rgba: 'rgba(255, 159, 90, 0.16)',
    },
    [DATA_TYPE.COMPETITIVE]: {
      color: '',
      rgba: '',
    },
    [DATA_TYPE.BLIP]: {
      color: '#0096FA',
      rgba: 'rgba(0, 150, 250, 0.16)',
    },
    [DATA_TYPE.SAC_LISTENING]: {
      color: '#09A738',
      rgba: 'rgba(9, 167, 56, 0.16)',
    },
  },
  ui: {
    red: '#cc1c14',
    steel: '#7b7b81',
  },
  ratingVerySatisfiedColor: '#1968F0',
  ratingSatisfiedColor: '#1BA766',
  ratingNeutralColor: '#FBCF23',
  ratingUnsatisfiedColor: '#F06305',
  ratingVeryUnsatisfiedColor: '#E60F0F',
};
